import { Divider, Flex, PaperSection, type PaperSectionProps } from '@shared/components';

import { ProctorDocumentFields, type ProctorDocumentFieldsProps } from '../proctor-document-fields';
import {
  ProctorEmployeeInformationFields,
  type ProctorEmployeeInformationFieldsProps,
} from '../proctor-employee-information-fields';
import {
  ProctorPersonalInformationFields,
  type ProctorPersonalInformationFieldsProps,
} from '../proctor-personal-information-fields';
import { ProctorTypeField, type ProctorTypeFieldProps } from '../proctor-type-field';

export type ProctorRequestFormFieldsProps = Omit<PaperSectionProps, 'title'> & {
  fields: {
    proctorType: ProctorTypeFieldProps['fields']['proctorType'];
    personal: ProctorPersonalInformationFieldsProps['fields'];
    employeeInfo: ProctorEmployeeInformationFieldsProps['fields'];
    documents: ProctorDocumentFieldsProps['fields'] & {};
  };
  options?: ProctorEmployeeInformationFieldsProps['options'] & {
    hideIdentificationFiles?: ProctorDocumentFieldsProps['hideIdentificationFiles'];
  };
  slots?: {
    documentAlertAdornment?: ProctorDocumentFieldsProps['alertAdornment'];
  };
};

export default function ProctorRequestFormFields(props: Readonly<ProctorRequestFormFieldsProps>) {
  const { fields, slots, options, ...restProps } = props;
  return (
    <PaperSection title='ข้อมูลผู้คุมสอบ' {...restProps}>
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
      >
        <ProctorTypeField fields={{ proctorType: fields.proctorType }} />
        <Divider />
        <ProctorPersonalInformationFields fields={fields.personal} />
        <Divider />
        <ProctorEmployeeInformationFields fields={fields.employeeInfo} options={props.options} />
        <ProctorDocumentFields
          alertAdornment={slots?.documentAlertAdornment}
          fields={{ ...fields.documents }}
          hideIdentificationFiles={options?.hideIdentificationFiles}
        />
      </Flex>
    </PaperSection>
  );
}
